<template>
  <div class="app">
<carousel firstslide="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fheader%2Flegal.jpg?alt=media&token=061f723c-22aa-4d7a-80d8-2f44fd25edbc" secondslide="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fheader%2Flegal.jpg?alt=media&token=061f723c-22aa-4d7a-80d8-2f44fd25edbc" thirdslide="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fheader%2Flegal.jpg?alt=media&token=061f723c-22aa-4d7a-80d8-2f44fd25edbc" />
       <mdb-container class="legalinfo"> 
            <mdb-card-title class="mt-4 h2">Legal</mdb-card-title>
           <p> 
AMERICAN CLASSICS LLC <br />
3441 21st Ave. SW<br />
Naples, Florida 34117<br />
Tel. 001-305-505-2052<br />
www.amclass-autotransport.com<br />
info@amclass-autotransport.com<br />
 
</p>
Rechtshinweis

Die Informationen dieser Internetseiten sind ein Service von American Classics LLC und dienen ausschließlich zur Information von Besuchern dieser Website. Für Richtigkeit, Vollständigkeit und Aktualität können weder American Classics LLC noch Dritte die Haftung übernehmen. Haftungsansprüche gegen American Classics LLC, die sich auf Schäden materieller oder ideeller Art beziehen, welche durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens American Classics LLC kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle Angebote sind freibleibend und unverbindlich. American Classics LLC behält es sich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen. Für Internetseiten Dritter, auf welche American Classics LLC durch Hyperlink verweist, tragen die jeweiligen Anbieter die Verantwortung; American Classics LLC ist nicht für den Inhalt solcher Seiten Dritter verantwortlich. Des Weiteren können die Web-Seiten von American Classics LLC ohne Wissen der zugehörigen Unternehmen von anderen Web-Seiten mittels Hyperlink angelinkt worden sein. American Classics LLC übernimmt keine Verantwortung für Darstellungen, Inhalt oder irgendeine Verbindung zu ihren Unternehmen in Web-Seiten Dritter. Inhalt und Struktur der Web-Seite von American Classics LLC sind urheberrechtlich geschützt. Die Vervielfältigung von Informationen oder Daten, insbesondere die Verwendung von Texten, Textteilen oder Bildmaterial bedarf der ausdrücklichen vorherigen Zustimmung.

Alle Angaben gemäß TDG (Teledienstgesetz).
 </mdb-container>
  </div>
</template>
<style lang="scss" scoped>

.legalinfo {
 padding: 5rem 3rem 5rem 3rem;
}
</style>
<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbIcon,
  mdbCardTitle,
  mdbJumbotron,
  mdbNavItem,
  mdbListGroup,
  mdbEdgeHeader
} from "mdbvue";
import carousel from "@/components/carousel";

export default {
  name: "legal",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbJumbotron,
    mdbCardTitle,
    mdbNavItem,
    mdbListGroup,
    mdbEdgeHeader,
    carousel
  }
};
</script>